import {
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_START,
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_SUCCESS,
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_FAIL,

} from "../../../constants";
import {
    FETCH_DEV_AND_STRENGTH_VISUALIZATION_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const getDevAndStrengthVisualization = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_DEV_AND_STRENGTH_VISUALIZATION_START, { ...payload })
        );
        return apiBaseInstance
            .post(FETCH_DEV_AND_STRENGTH_VISUALIZATION_URL, {
                benchmarkFilters: payload, ...getProjectIdAndOrgId(payload),currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_DEV_AND_STRENGTH_VISUALIZATION_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb()
            })
            .catch((err) => {
                dispatch(withType(FETCH_DEV_AND_STRENGTH_VISUALIZATION_FAIL, { ...err, ...payload }));
                cb && cb()
            });
    };
};

